import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PinAccessDialog from "./PinAccessDialog";
import {
  getCachedPinAccess,
  subscribeToPinAccess,
} from "../utils/pinAccessCache";

interface PinProtectedRouteProps {
  children: React.ReactNode;
}

const PinProtectedRoute: React.FC<PinProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const { businessId } = useParams();
  const [unlocked, setUnlocked] = React.useState(getCachedPinAccess());
  const [dialogOpen, setDialogOpen] = React.useState(!unlocked);

  React.useEffect(() => {
    const unsubscribe = subscribeToPinAccess((granted) => {
      setUnlocked(granted);
      if (!granted) {
        setDialogOpen(true);
      }
    });
    return unsubscribe;
  }, []);

  const handleClose = () => {
    setDialogOpen(false);
    if (!getCachedPinAccess()) {
      const fallback = businessId ? `/dashboard/${businessId}` : "/dashboard";
      navigate(fallback);
    }
  };

  const handleVerified = () => {
    setUnlocked(true);
    setDialogOpen(false);
  };

  if (!unlocked) {
    return (
      <PinAccessDialog
        open={dialogOpen}
        onClose={handleClose}
        onVerified={handleVerified}
      />
    );
  }

  return <>{children}</>;
};

export default PinProtectedRoute;
